<template>
    <div class="infinite-scroll-container">
        <a-switch :checked="checked"
            v-on:change="checked => this.checked = checked"
        > 
        </a-switch>
        <a-button
            v-on:click="addPic"
        >
            Add
        </a-button>
        <a-button
            v-on:click="rmPic"
        >
            Remove
        </a-button>
        <div
            v-if="checked"
            class="masked-holder"
        >
            <MaskedSlideTransition 
                :animSpeed="speed"
            >
                <div
                    :style="{
                        margin: 'auto',
                        padding: '50px',
                        backgroundColor: 'purple',
                        color: 'white',
                        textAlign: 'center',
                        width: '400px',
                        height: '600px'
                    }"
                >
                    <h1>TESZT helo</h1>
                </div>
            </MaskedSlideTransition>
        </div>
        <StaggeredListTransition
            class="infinite-transition-group"
        >
            <img
                v-for="(img, ix) in images"
                :key="`${img.id}_${ix}`"
                :slot="`slot-content-${ix}`"
                :src="img.src"
            />
        </StaggeredListTransition>
        <Observer v-on:intersect="loadEntries" />
    </div>
</template>

<script>
import MaskedSlideTransition from '@/transitions/MaskedSlideTransition.vue';
import StaggeredListTransition from '@/transitions/StaggeredListTransition.vue';
import Observer from '@/components/Observer.vue';

import Lava from '@/assets/lava.jpg'
import Castle from '@/assets/castle.jpg'

import Borok from '@/assets/borok.jpg'
import Borek from '@/assets/borek.jpg'
import Trump1 from '@/assets/trump1.jpg'
import Trump2 from '@/assets/trump2.jpg'

import uuidv4 from 'uuid/v4'


export default {

    components: {
        MaskedSlideTransition,
        StaggeredListTransition,
        Observer
    },

    data() {
        return {
            checked: false,
            speed: 1,

            images: [],

            sourceImages: [
                Lava  ,
                Castle,
                Borok ,
                Borek ,
                Trump1,
                Trump2,
            ]
        }
        
    },
    computed: {
        generatedImages() {
            let genImages = [];

            for (let i = 0; i < 3; i++) {
                let img = 
                genImages.push(...this.images)
            }
            return genImages;
        }
    },
    created() {
        this.addPic();
        this.addPic();
        this.addPic();
        this.addPic();
        this.addPic();
        this.addPic();
        this.addPic();
        this.addPic();
        this.addPic();
        this.addPic();
        this.addPic();
        this.addPic();
    },
    methods: {
        randInt(max) {
            return Math.round(Math.random() * Math.floor(max)) 
        },
        
        addPic() {
            let newImages = [...this.images];
            let src = this.sourceImages[this.randInt(this.sourceImages.length -1)];
            let newImage = {
                src,
                id: uuidv4()
            }

            newImages.push(newImage)
            this.images = newImages;
        },
        rmPic() {
            let newImages = [...this.images];
            let ix = this.randInt(newImages.length);

            newImages.splice(ix, 1);
            
            this.images = newImages;
        },
        loadEntries() {
            this.addPic();
            this.addPic();
            this.addPic();
        }
    }



}
</script>

<style lang="scss" scoped>
    .masked-holder {
        display: grid;
        grid-gap: 25px;
        grid-template-columns: 1fr 1fr;
    }

    .infinite-transition-group {
        display: grid;
        grid-template-columns: 1fr;
        margin: 15px;
        grid-gap: 50px;

        @include sm {
            grid-template-columns: 1fr 1fr;
        }

        @include md {
            grid-template-columns: 1fr 1fr 1fr;
        }

        
    }
</style>
